import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { usePartnerCallbackCreate } from 'domains/connect/api/callback-testing/partnerCallbackCreate.hooks'
import { usePartnerId } from 'utils/routing/params.hooks'
import { type SimpleOption } from 'legacy/dash-blocks/dash-select/utils/select.types'
import { useErrorNotification } from 'domains/connect/components/utils/notifications.hooks'

export const useCallbackTestingForm = () => {
  const partnerId = usePartnerId()
  const { register, errors, handleSubmit, setValue } = useForm()
  const { createPartnerCallback, callbackResponse, loading, error } = usePartnerCallbackCreate()
  useErrorNotification(error, 'connect.callback-testing.response.error')
  const onSubmit = handleSubmit(data => {
    createPartnerCallback({ partnerId, orderId: data.orderId, event: data.eventName })
  })
  const [eventName, setEventName] = useState<SimpleOption<string>>(null)
  const handleEventNameChange = (selected: SimpleOption<string>) => {
    setEventName(selected)
    setValue('eventName', selected.value)
  }
  const orderIdFieldRef = register({ required: true })
  useEffect(() => {
    register({ name: 'eventName', required: true })
  }, [register])
  return {
    onSubmit,
    errors,
    orderIdFieldRef,
    eventName,
    handleEventNameChange,
    callbackResponse,
    callbackLoading: loading,
    callbackError: error,
  }
}
